<template>
  <y-block-box title="来源渠道">
    <template #suffix>
      <btn-change-group :items="btnItems" v-model="selectedBtn"></btn-change-group>
    </template>
    <div v-loading="loading" class="content-box">
      <div class="main-channel-box" v-if="selectedBtn === 'main'">
        <div class="main-channel-item" v-for="(item,index) in renderData">
          <div :title="`比上月增加${item.delta}`" style="display: flex;justify-content: space-between;">
            <div class="main-channel-title">{{ item.name }}</div>
            <div :class="['delta-item',item.delta > 0 ? 'delta-up' : 'delta-none']">
              <span v-if="item.delta">{{item.delta}}</span>
            </div>
          </div>
          <div>
            <div class="main-channel-value">{{ item.count }}</div>
            <div class="y-progress-box">
              <div class="y-progress-content" :style="`width:${item.rate}%;background:${renderColor[index]}`"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="selectedBtn === 'other'" style="height: 100%;overflow: auto;width: 100%;">
        <el-table :data="resData">
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="name" label="渠道" align="center"></el-table-column>
          <el-table-column prop="count" label="总量" align="center"></el-table-column>
          <el-table-column prop="delta" label="增量" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
  </y-block-box>
</template>

<script>
export default {
  name: "SourceChannel",
  data(){
    return{
      btnItems:[
        {text:'主要渠道',value:'main'},
        {text:'全部数据',value:'other'},
      ],
      renderColor:[
        '#0C88F0',
        '#00CC99',
        '#8166F4',
        '#0CC1CB',
        '#FFBF3B',
        '#F8696C'
      ],
      resData:[],
      selectedBtn:'main',
      loading:false,
    }
  },
  computed:{
    renderData(){
      const mainData = this.resData.slice(0,6)
      const sum = mainData.reduce((sum, item) => sum + item.count, 0);
      return mainData.map(item => {
        return {
          name:item.name,
          count:item.count,
          delta:item.delta,
          rate: Math.ceil((item.count / sum) * 100)
        }
      })
    }
  },
  mounted(){
    this.queryData();
  },
  methods:{
    async queryData(){
      this.loading = true
      let res = await this.$callApi("board.getChannelCount");
      this.resData = res.data;
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';
.content-box{
  height: 146px;
  width: 100%;
  overflow: auto;
}
.main-channel-box{
  height:100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: min-content; /* 行高自适应内容 */
  gap: 16px;
  .main-channel-item{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .main-channel-title{
      color: #73767B;
    }
    .main-channel-value{
      color: #131313;
      font-size: @font-size-xlg;
      font-weight: bold;
    }
  }
}
.y-progress-box{
  height: 8px;
  background: #F7FAFF;
  border-radius: 10px;
  position: relative;
  &:before{
    content: '';
    border-radius: 10px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: inset 0 0 4px 0 #E6E6E6;
  }
  .y-progress-content{
    width: 50%;
    height: 100%;
    background: #FFBE34;
    border-radius: 10px 0 0 10px;
  }
}
.delta-item{
  font-size: 12px;
  &.delta-up{
    color: #05C98F;
    display: flex;
    gap: 2px;
    &:after{
      content: '↑';
    }
  }
  &.delta-down{
    color: #F82F2F;
    display: flex;
    gap: 2px;
    &:after{
      content: '↓';
    }
  }
  &.delta-none{
    color: #F82F2F;
    display: flex;
    gap: 2px;
    &:after{
      content: '--';
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/board/components/SourceChannel/SourceChannel.vue